import { RegistrationFlow, SettingsFlow } from "@ory/client";
import { CustomLanguageFormats, locales } from "@ory/elements";

export const customTranslations: CustomLanguageFormats = {
  fr: {
    ...locales.fr,
    "login.title": "Connexion",
    "identities.messages.1010022": "Se connecter",
    "registration.title": "Créer votre compte",
    "identities.messages.1080002":
      "Votre compte a été vérifié avec succès. Vous pouvez maintenant vous connecter.",
    "identities.messages.1050001":
      "Vos modifications ont été enregistrées avec succès ! Vous pouvez désormais réserver un trajet.",
    "identities.messages.4000001":
      "Le mot de passe doit contenir au moins 12 caractères.",
    "identities.messages.1040009":
      "Veuillez choisir un mot de passe pour vous authentifier.",
  },
  en: {
    ...locales.en,
    "identities.messages.4000001":
      "Password must contain at least 12 characters.",
  },
};

export function translateFlow<T extends RegistrationFlow | SettingsFlow>(
  t: (s: string) => string,
  flow: T,
): T {
  const translations = [
    { key: "traits.lastname", value: t("Lastname") },
    { key: "traits.firstname", value: t("Firstname") },
  ];
  const translationMap = Object.fromEntries(
    translations.map(({ key, value }) => [key, value]),
  );

  return {
    ...flow,
    ui: {
      ...flow.ui,
      nodes: flow.ui.nodes.map((n) => {
        if (n.attributes.node_type === "input") {
          const key = n.attributes.name;
          if (
            Object.prototype.hasOwnProperty.call(translationMap, key) &&
            n.meta?.label
          ) {
            n.meta.label.text = translationMap[key];
          }
          if (n.meta?.label?.context) {
            n.meta.label.context = { ...n.meta.label.context, title: t(key) };
          }
        }
        return n;
      }),
    },
  };
}
